import { render, staticRenderFns } from "./ThreeDecimalGrammage.vue?vue&type=template&id=88f52d28&scoped=true"
import script from "./ThreeDecimalGrammage.vue?vue&type=script&lang=js"
export * from "./ThreeDecimalGrammage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f52d28",
  null
  
)

export default component.exports